import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { Wrapper, Section, Paragraph } from "../components/styles/container"
import { VerticalCard } from "../components/card"

import BahnhofWest from "../images/bad-nauheim_bahnhof_west.jpg"
import Technik from "../images/technik.jpg"
import Kaiserstrasse from "../images/kaiserstrasse_nord_friedberg.jpg"
import Burgtor from "../images/burgtor_friedberg_kaiserstrasse.jpg"

// markup
const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Startseite" />
      <Wrapper>
        <Section className="flex vertical l-horizontal">
          <div>
            <h2>
              Aktuelle Bilder von Burgtor, Kaiserstraße, „Altes Hallenbad“ und
              weiteren Sehenswürdigkeiten
            </h2>
            <div>
              <h3>Werbung für die Region mit Videotechnik</h3>
              <Paragraph>
                In Verbundenheit mit dem Unternehmensstandort Friedberg in der
                Mitte Hessens wirbt SAFETEC mit der Einrichtung und Unterhaltung
                einiger Webcams für diese verkehrsgünstig gelegene Stadt und
                Region im Dunstkreis Frankfurts.
              </Paragraph>
            </div>
            <div className="grid col-1 md-col-2 gap-1 top-space">
              <VerticalCard
                headline="Webcam Kaiserstraße Nord "
                img={Kaiserstrasse}
                buttonText="Zur Webcam"
                buttonLink="/kaiserstr-nord"
              >
                Bereits mit der Gründung der Stadt im späten 12. Jahrhundert
                hatte die Kaiserstraße als Markt- und Handelsstraße große
                Bedeutung.
              </VerticalCard>
            </div>
            <div className="top-space">
              <h3>SAFETEC Timo Durchdewald Sicherungstechnik</h3>
              <Paragraph>
                Einer der Kernbereiche der Elektronikabteilung ist die
                Videotechnik. Die vielfältigen Anwendungen von der einfachen
                Überwachung von Hauseingängen über Videokonzepte für den Groß-
                und Einzelhandel, die Überwachung von automatischen
                Fertigungsstraßen bis hin zur Einbindung in
                Perimeter-Schutzsystemen werden durch SAFETEC projektiert,
                installiert und gewartet/instand gehalten.
              </Paragraph>
            </div>
          </div>
          <div className="flex between vertical md-horizontal bg-grid-appear col-2 l-flex-appear l-vertical">
            <VerticalCard
              headline="Neue externe Webcam"
              img={BahnhofWest}
              buttonText="Zur Webcam"
              buttonLink="/bad-nauheim"
            >
              Bad Nauheim mit Blickachse Bahnhofsallee – Sprudelhof –
              Johannisberg
            </VerticalCard>
            <VerticalCard
              headline="Technik"
              img={Technik}
              buttonText="Mehr über die Technik"
              buttonLink="/technik"
            >
              Hier erfahren Sie mehr über die eingesetzte Technik, Kameras, etc.
            </VerticalCard>
          </div>
        </Section>
      </Wrapper>
    </Layout>
  )
}

export default IndexPage
